import { Avatar } from '@mui/material';
import styled from 'styled-components';

import { ColorHex } from './types';

interface AvatarProps {
  initials?: string,
  imageUrl?: string,
  color?: ColorHex,
  size?: number,
}

const ProfileAvatar = styled(Avatar)<AvatarProps>`
  && {
    background-color: ${({ color }) => color};
    height: ${({ size }) => size}px;
    width: ${({ size }) => size}px;
    font-size: calc(${({ size }) => size}px / 2.25);
    color: ${({ theme }) => theme.palette.common.white};
  }
`;

export { ProfileAvatar };
